define((require) => {
    "use strict";

    var Class = require("shared/util/Class");

    /**
     * The abstract base class for all editor activities.
     *
     * @class EditorActivity
     * @author Kim
     */
    return Class.extend({

        _undone: false,

        isUndone: function() {
            return this._undone;
        },

        /**
         * Undo this activity.
         */
        undo: function() {
            if (!this._undone) {
                this._onUndo();
                this._undone = true;
            }
        },

        /**
         * Redo this activity.
         *
         * Redo is only performed for an activity that was previously undone.
         */
        redo: function() {
            if (this._undone) {
                this._onRedo();
                this._undone = false;
            }
        },

        /**
         * @protected
         *
         * Protected method that performs the actual undo
         * logic, should be overridden by the subclass.
         */
        _onUndo: function() {

        },

        /**
         * @protected
         *
         * Protected method that performs the actual rodo
         * logic, should be overridden by the subclass.
         */
        _onRedo: function() {

        },

        /**
         * Disposes the activity.
         */
        dispose: function() {

        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/activity/EditorActivity.js